var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getShow)?_c('div',{staticClass:"ibx-app-header__view-only"},[_vm._m(0),_c('div',{staticClass:"ibx-app-header__view-only-close",on:{"click":_vm.onClickClose}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'times']}})],1)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-app-header__view-only-text"},[_c('span',[_vm._v("You are currently in view-only mode.")])])
}]

export { render, staticRenderFns }